import { HomeOutlined } from '@ant-design/icons';
import { Button, Card, Flex, Typography } from '@contiple/antd-ds';
import { useTranslation } from 'react-i18next';
import { HOME_URL } from '../../constants';

const InternalServerError = () => {
  const { t } = useTranslation();

  const handleGoHome = () => {
    window.location.href = HOME_URL || '/';
  };

  return (
    <Flex
      vertical
      gap="16px"
      align="center"
      justify="center"
      style={{ minHeight: '60vh' }}>
      <Card style={{ width: 400, textAlign: 'center' }}>
        <Typography.Title level={2} style={{ color: '#faad14' }}>
          {t('errorPage.internalServerError.title')}
        </Typography.Title>
        <Typography.Paragraph>
          {t('errorPage.internalServerError.description')}
        </Typography.Paragraph>
        <Button type="primary" icon={<HomeOutlined />} onClick={handleGoHome}>
          {t('errorPage.internalServerError.contactAdmin')}
        </Button>
      </Card>
    </Flex>
  );
};

export default InternalServerError;
